import ComplianceAuditTaskDetailsPage from "@components/common/ComplianceAuditDetail/TaskDetails";
import ComplianceAuditTaskHistoryPage from "@components/common/ComplianceAuditDetail/TaskHistory";
import ComplianceCompletedAudit from "@pages/ComplianceAudit/CompletedAudit";
import CompliancePendingAudit from "@pages/ComplianceAudit/PendingAudit";

export const ComplianceAuditRoutes = [
	// activities
	//my task
	{
		path: "/audit/compliance-audit/pending-audit",
		name: "audit_compliance_audit_pending",
		component: CompliancePendingAudit,
	},
	{
		path: "/audit/compliance-audit/pending-audit/task-details/:id/:checkpoint_id",
		name: "audit_compliance_audit_pending",
		component: ComplianceAuditTaskDetailsPage,
	},
	{
		path: "/audit/compliance-audit/pending-audit/task-history/:id/:checkpoint_id",
		name: "audit_compliance_audit_pending",
		component: ComplianceAuditTaskHistoryPage,
	},

	//pending travel
	{
		path: "/audit/compliance-audit/completed-audit",
		name: "audit_compliance_audit_completed",
		component: ComplianceCompletedAudit,
	},
	{
		path: "/audit/compliance-audit/completed-audit/task-details/:id/:checkpoint_id",
		name: "audit_compliance_audit_completed",
		component: ComplianceAuditTaskDetailsPage,
	},
	{
		path: "/audit/compliance-audit/completed-audit/task-history/:id/:checkpoint_id",
		name: "audit_compliance_audit_completed",
		component: ComplianceAuditTaskHistoryPage,
	},
];
